<template>
    <v-col class="co-relatorios">
        <barra-saldo ref="refBarraSaldo"/>
        <div v-if="mostrarFiltrosVigencia" class="d-flex filtros-vigencia-wrapper">
            <button v-for="filtro in filtrosVigenciaDisponiveis"
                class="filtros-vigencia-botoes"
                :class="ehFiltroVigenciaSelecionado(filtro) ? 'filtro-active' : ''"
                @click="selecionarFiltroVigencia(filtro)"
            >
                {{ filtro }}
            </button>
        </div>
        <v-row no-gutters class="select-relatorios">
            <v-select
                v-model="tipoRelatorioSelecionado"
                v-validate="'required'"
                class="required-field"
                :error-messages="errors.collect('Tipo Relatório')"
                :items="tiposRelatorio"
                label="Selecione o tipo de relatório"
                name="Tipo de relatório"
                placeholder="Selecione"
                persistent-placeholder
            />
        </v-row>
        <v-row no-gutters>
            <v-spacer/>
            <v-btn class="mt-4 mr-12"
                    color="primary"
                    :disabled="!tipoRelatorioSelecionado"
                    :loading="carregandoRelatorio"
                    @click="gerar">
                Gerar
            </v-btn>
        </v-row>

        <dialog-default-confirmar-acao
            v-if="dialogdefaultConfirmaAcao"
            :dialog="dialogdefaultConfirmaAcao"
            sentimento="assustado"
            titulo="Poxa, você não tem acesso a esse tipo de funcionalidade"
            subtitulo='Contrate um de nossos planos para poder utilizar essa funcionalidade. Clique em "Sim, eu quero" para conhecer nossas opções 🚀'
            label-botao-principal="Sim, eu quero!"
            @acao-principal="acaoDialogDefaultConfirmaAcao"
            @fechar="fecharDialogDefaultConfirmarAcao"
        />
    </v-col>
</template>

<script>
import BarraSaldo from '@/views/home/meus-contratos/components/BarraSaldo'
import DialogDefaultConfirmarAcao from '@/commons/components/dialogs/DialogDefaultConfirmarAcao'
import {actionTypes} from '@/commons/constants'
import {mapGetters} from 'vuex'
import moment from 'moment'

export default {
    name: "Relatorios",
    components: {
        BarraSaldo,
        DialogDefaultConfirmarAcao
    },
    data() {
        return {
            tipoRelatorioSelecionado: null,
            tiposRelatorio: [
                {text: `${this.$tc("pt_br.signatario", 2)} com pendência de assinatura`, value: {tipo: 'SIGNATARIOS_PENDENCIA_ASSINATURA', free: false}},
                {text: `Vigência de ${this.$tc("pt_br.documento", 2)}`, value: {tipo: 'VIGENCIA_DOCUMENTO', free: true}},
            ],
            carregandoRelatorio: false,
            dialogdefaultConfirmaAcao: false,
            mostrarFiltrosVigencia: false,
            filtrosVigenciaDisponiveis: ['Todos', 'A Vencer', 'Vencidos'],
            filtroVigenciaSelecionado: 'Todos'
        }
    },
    mounted() {
        this.$store.state.loki.page.title = 'Relatórios'
    },
    computed: {
        ...mapGetters(['ehPlanoFree'])
    },
    watch: {
        'tipoRelatorioSelecionado'(val) {
            if (val.tipo === 'VIGENCIA_DOCUMENTO') {
                this.mostrarFiltrosVigencia = true
                this.filtroVigenciaSelecionado = 'Todos'
            } else {
                this.filtroVigenciaSelecionado = null
                this.mostrarFiltrosVigencia = false
            }
        },
    },
    methods:{
        acaoDialogDefaultConfirmaAcao() {
            this.$router.push({name: 'planos'})
        },
        async gerar() {
            this.carregandoRelatorio = true

            if (this.ehPlanoFree && !this.tipoRelatorioSelecionado.free) {
                this.abriDialogDefault()
                this.carregandoRelatorio = false
                return
            }

            const tipoRelatorio = this.tipoRelatorioSelecionado.tipo === 'VIGENCIA_DOCUMENTO' ? actionTypes.RELATORIO.GERAR_VIGENCIA_DOCUMENTO : actionTypes.RELATORIO.GERAR_SIGNATARIOS_PENDENCIA_ASSINATURA

            try {
                const url = await this.$store.dispatch(tipoRelatorio, {filtroVigencia: this.filtroVigenciaSelecionado})

                if (url.message) {
                    this.mostrarNotificacaoErro(url.message.substring(2, url.message.length - 2))
                    this.carregandoRelatorio = false
                    return
                }

                this.montarDownloadArquivo(url)
            } catch {
                this.mostrarNotificacaoErro('Ocorreu um erro ao gerar o relatório!')
            } finally {
                this.carregandoRelatorio = false
            }
        },
        abriDialogDefault() {
            this.dialogdefaultConfirmaAcao = true
        },
        ehFiltroVigenciaSelecionado(filtro) {
            return filtro === this.filtroVigenciaSelecionado
        },
        fecharDialogDefaultConfirmarAcao() {
            this.dialogdefaultConfirmaAcao = false
        },
        montarNomeArquivo(data) {
            if (this.tipoRelatorioSelecionado.tipo === 'SIGNATARIOS_PENDENCIA_ASSINATURA') {
                return `relatorio-${this.$tc("pt_br.signatario", 2).toLowerCase()}-pendencia-assinatura-${data}.xls`
            } else if (this.tipoRelatorioSelecionado.tipo === 'VIGENCIA_DOCUMENTO'){
                return `relatorio-vigencia-${this.$tc("pt_br.documento", 2).toLowerCase()}-${data}.xls`
            }
        },
        montarDownloadArquivo(url) {
            const a = document.createElement('a')

            const dataRelatorio = moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
            const dataRelatorioArquivo = dataRelatorio.toString().replaceAll(":", "-").replaceAll("/", "-").replaceAll(" ", "-")

            document.body.appendChild(a)
            a.href = url
            a.download = this.montarNomeArquivo(dataRelatorioArquivo)
            a.click()
            window.URL.revokeObjectURL(url)
        },
        selecionarFiltroVigencia(filtro) {
            this.filtroVigenciaSelecionado = filtro
        }
    }
}
</script>

<style lang="stylus">
.co-relatorios
    background-color var(--background-100)
    flex-direction column
    gap 15px
    padding 0

    .select-relatorios
        padding 20px

    .filtros-vigencia-wrapper
        gap 25px
        align-items center
        padding 20px 20px 0px 20px

        .filtros-vigencia-botoes
            font-size 13px
            color var(--text-color-200)

        .filtro-active
            font-size 13px
            font-weight 600
            color var(--primary)


</style>
